import React from 'react';
import BotAvatar from '../bot-avatar/BotAvatar';

export const StepContentBody = ({
  title,
  content,
  contentJustify = false,
  isCardView = false,
  showBotAvatar = true,
}) => {
  const cardClasses = isCardView
    ? { div: 'card-body p-2', h5: 'card-title', p: 'card-text' }
    : { div: '', h5: '', p: '' };

  return (
    <>
      {showBotAvatar && <BotAvatar />}
      <div className={`${cardClasses.div} text-dark`}>
        <h5 className={`${cardClasses.h5} textSize18 font-weight-bold mb-2`}>
          {title}
        </h5>
        <p
          className={`${cardClasses.p} ${
            contentJustify ? 'text-justify' : ''
          } textSize14`}
        >
          {content}
        </p>
      </div>
    </>
  );
};

function StepContent({
  showBotAvatar = true,
  titleImageSrc,
  titleImageAlt,
  title,
  content,
}) {
  return (
    <div className='row'>
      <div className='col-12'>
        {showBotAvatar && <BotAvatar />}
        <div className='card'>
          <div className='border w-100'>
            <img className='w-100' src={titleImageSrc} alt={titleImageAlt} />
          </div>
          <StepContentBody
            title={title}
            content={content}
            showBotAvatar={false}
            isCardView
            contentJustify
          />
        </div>
      </div>
    </div>
  );
}

export default StepContent;
